import { useAppSelector } from 'app/store/store.hooks';

const useGoodInBasket = () => {
  const currentBasket = useAppSelector((state) => state.basket.currentBasket);

  const getGoodInBasket = (id: number): boolean => {
    const good = currentBasket?.goods.find((item) => item.goodId === id);

    return !!good;
  };

  return { getGoodInBasket };
};

export const GoodHooks = {
  useGoodInBasket,
};
